import $ from "jquery";
import { i18nObject } from "../i18n/i18n-util";
import { Locales } from "../i18n/i18n-types";
import { defer } from "../main";
import { loadAllLocales } from "../i18n/i18n-util.sync";
import { categories_by_id } from "./categories";
import { ProductComparatorsService } from "./productComparatorService";
import { VueWebAppService } from "../submodules/vueService";
import SearchApiService from "./services/apis/foxigy/search";
import { defineCustomElement } from "vue";
import FooterComponent from "../submodules/FooterComponent.vue";

export class Services {
    private _cartSummary: boolean;
    private _navbarInit: boolean;
    private _footerImage: boolean;
    private _categoryPageBackground: boolean;
    private _productRatingElement: boolean;
    private _footerAdjustment: boolean;
    private _cartAdjustment: boolean;
    private _localizator: boolean;
    private _descriptionShortener: boolean;
    private _newFooterComponent: boolean;
    private _productComparatorsService: ProductComparatorsService;
    private _vueWebAppService: VueWebAppService;
    private _searchApiService: SearchApiService;

    private _basePluginUrl = basePluginUrl;

    constructor(private _config?: any) {}

    getBasePluginUrl() {
        return this._basePluginUrl;
    }

    getLanguage() {
        if (typeof upgates !== "undefined") {
            return upgates?.language?.replace("sl", "si") || "sk";
        } else if (typeof shoptet !== "undefined") {
            if (/\.cz/.test(window.location.host)) {
                return "cz";
            } else {
                return "sk";
            }
        } else {
            return "sk";
        }
    }

    getLocalizator() {
        if (!this._localizator) {
            loadAllLocales();
            this._localizator = true;
        }
        return i18nObject(this.getLanguage() as Locales);
    }

    navbarInit(): boolean {
        if (!this._navbarInit) {
            $(".navbar-nav.navbar-menu li.nav-item:not(.d-xl-none) ~ .nav-item-divider").first().remove();
            $(".navbar-nav.navbar-menu li.nav-item:not(.d-xl-none)").remove();

            const navbarLogo = $(`<a href = '/'><img class='navbar-logo' style="display:none;visibility:hidden;"
            src="${this._basePluginUrl}/foxigy-logo-yellow.webp" 
            ></a>`);
            navbarLogo;
            const navbarStyle = $(`
            <style id="navbar-style">
                .navbar.bg-size-cover  {
                    background-image: url("${
                        this._basePluginUrl
                    }/navbar/${this.getLanguage()}_navbar_foxigy.webp" ) !important;
                    background-position: left !important;
                    background-repeat: no-repeat !important;
                    background-size: cover;
                }
                .header-show .navbar-logo  {
                    width: 150px;
                    margin-left: 0px;
                    visibility:visible !important;
                    display: inline !important;
                }
                .header-hide .navbar-logo  {
                    display:none;
                    visibility:hidden !important;
                    display:none !important
                }
            </style>`);
            $("header").append(navbarStyle);

            navbarLogo.prependTo("header .header-bottom .container");

            console.log($(".ScrollToTop"));
            $(".ScrollToTop").css("bottom", "50px");

            // defer(
            //     () => {
            //         return $("[title='Live chat button'] > div").length > 1;
            //     },
            //     () => {
            //         $("[title='Live chat button'] > div").css("bottom", "120px;");
            //     }
            // );

            this._navbarInit = true;
        }
        return this._navbarInit;
    }

    cartSummary(): boolean {
        if (!this._cartSummary) {
            const cummaryColumn = $(
                "div.x.bg-white.hidden-bg-color.column.column-left.pt-0.px-xl-3.pb-6.col-l-c.text-left.rem-col.position-relative.ColumnPage"
            ).has("#snippet--totalPriceAjax");

            cummaryColumn.detach().appendTo("main");
            cummaryColumn.css("cssText", "position:relative !important");

            $("tr.shp-pay-card-heading").remove();
            $("#snippet--totalPriceAjax ~ aside#col.carousel").remove();

            this._cartSummary = true;
        }
        return this._cartSummary;
    }

    footerImage() {
        if (!this._footerImage) {
            const imageElement = $(
                `<img class="container text-c-muted max-w-xxl" src="${
                    this._basePluginUrl
                }/footer/${this.getLanguage()}_footer_foxigy.webp" ></img>`
            );

            imageElement.insertBefore("footer");
            this._footerImage = true;
        }
        return this._footerImage;
    }

    async categoryPageBackground() {
        if (!this._categoryPageBackground) {
            if (upgates) {
                if (upgates !== undefined && upgates.pageType === "category") {
                    const imageElement = $("main > article");
                    // for (const pathElement of upgates.category.path.reverse()) {
                    categories_by_id;
                    const currCategory = Object.values(categories_by_id).find(
                        cat => cat.code === upgates?.category.code
                    );
                    while (currCategory) {
                        if (currCategory.hasImage) {
                            try {
                                imageElement.css(
                                    "background-image",
                                    `url(${this._basePluginUrl}/category_background/${currCategory.code}.webp)`
                                );

                                imageElement.css("background-repeat", "no-repeat");
                                imageElement.css("background-size", "100%");
                                break;
                            } catch (err) {
                                console.log(err);
                            }
                            break;
                        }
                        // else if (currCategory.parent_id) {
                        //     currCategory = categories_by_id[currCategory.parent_id];
                        // }
                        else {
                            break;
                        }
                    }

                    $("#collapseSubcategories .bg-white").css("background-color", "#ffffff82");

                    // $("article::after").css("opacity", "0.6");
                    const afterStyle = $(`<style id="article-after-style">
                article:after {
                    opacity: 0 !important;
                }
                article:before {
                    background-image: none !important;
                }
              </style>`);
                    $("article").append(afterStyle);
                }
                this._categoryPageBackground = true;
            }
        }
    }

    productRatingElement() {
        if (!this._productRatingElement) {
            if ($("#reviews-tab").length) {
                const starsElementId = $("[id^=snippet-rating-main]")?.attr("id");
                console.log(starsElementId);
                $(`#${starsElementId}`).on("click", () => {
                    $([document.documentElement, document.body]).animate(
                        {
                            scrollTop: ($("#reviews")?.offset()?.top || 0) - ($("header")?.height() || 0)
                        },
                        500
                    );
                    $("#reviews-tab").trigger("click");
                });
                const afterStyle = $(`<style id="snippet-rating-main-css">
                #${starsElementId}:hover {
                    cursor: pointer;
                }
              </style>`);
                $(`#${starsElementId}`).append(afterStyle);
            }
        }
    }

    footerAdjustment() {
        if (!this._footerAdjustment) {
            // const firstRow = $("footer .row.text-sm-center-var.ftr-top ");
            // const menuElement = firstRow.children(".col-xl-17");
            // menuElement.attr("id", "first-footer-row");
            // menuElement.removeClass("col-xl-17");
            // menuElement.addClass("col-xl-22");
            // menuElement.addClass("pb-5");

            // const contactColumn = firstRow.children(".col-xl-7 ");
            // contactColumn.attr("id", "footer-contact-column");
            // contactColumn.detach();
            // const secondRow = $('<div class="row text-sm-center-var ftr-top"></div>');
            // secondRow.append(contactColumn);
            // $(secondRow).insertAfter(firstRow);

            // const benefitsColumn = $(
            //     `
            //     <aside data-designer="ftr-col-center" style="" class="col-xl-10 pb-6 text-xl-left row">
            //         <strong data-designer="ftr-cu" class="d-block mb-2 title col-xl-24 text-sm-center-var" style="font-size: 1.4rem;">
            //         ${this.getLocalizator()["footer"]["why-shop-with-us"]()}
            //         </strong>
            //         ` +
            //         (() => {
            //             let htmlSnippet = "";
            //             let heurekaImage = "";
            //             if (["hu", "ro", "bg", "sk", "si", "cz"].includes(this.getLanguage())) {
            //                 heurekaImage = `<div class="col-6"><img style="width: 100%;" src="${
            //                     this._basePluginUrl
            //                 }${this.getLocalizator()["footer"]["heureka-image-url"]()}">
            //                         </div>`;
            //             }
            //             if (["si"].includes(this.getLanguage())) {
            //                 heurekaImage += `
            //                 <div class="smdWrapperTag"></div>
            //                 `;
            //             }
            //             htmlSnippet =
            //                 heurekaImage +
            //                 `<div data-designer="ftr-opn" style="" class="pb-3 col-${
            //                     heurekaImage === "" ? "24" : "18"
            //                 }">
            //             <ul>
            //                 <li>${this.getLocalizator()["footer"]["benefits"]["first"]()}</li>
            //                 <li>${this.getLocalizator()["footer"]["benefits"]["second"]()}</li>
            //                 <li>${this.getLocalizator()["footer"]["benefits"]["third"]()}</li>
            //             </ul>
            //         </div> `;
            //             return htmlSnippet;
            //         })() +
            //         `

            //     </aside>
            //     `
            // );
            // secondRow.append(benefitsColumn);

            // const socialLinksColumn = $(`
            //     <aside data-designer="ftr-col-right" class="col-xl-7 pb-3 text-xl-left img-center row">
            //         <iframe class="col-24" src="${this.getLocalizator()["footer"]["social"][
            //             "facebook-plugin-url"
            //         ]()}" style="border:none;overflow:hidden" scrolling="no" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" width="340" height="130" frameborder="0"></iframe>
            //         <a class="col-4" href= "${this.getLocalizator()["footer"]["social"]["facebook-page-url"]()}">
            //             <img style="max-width: 50px;;" src="${this._basePluginUrl}/footer/img/facebook.webp" >
            //         </a>
            //         <a class="col-4" href= "${this.getLocalizator()["footer"]["social"]["youtube-page-url"]()}">
            //             <img style="max-width: 50px;" src="${this._basePluginUrl}/footer/img/youtube.webp" >
            //         </a>
            //         <a class="col-4" href= "${this.getLocalizator()["footer"]["social"]["instagram-page-url"]()}">
            //             <img style="max-width: 50px;;" src="${this._basePluginUrl}/footer/img/instagram.webp" >
            //         </a>
            //         <div class="col-xl-12">
            //         </div>
            //     </aside>
            //     `);
            // secondRow.append(socialLinksColumn);

            // const thirdRow = $('<div class="row text-sm-center-var ftr-top" data-designer="ftr-thrd-rw"></div>');
            // const yourFoxigySection = $(`
            //     <aside itemscope="" itemtype="http://schema.org/LocalBusiness" data-designer="ftr-col-left" class="col-xl-6 pb-3 text-xl-left">
            //     </aside>
            //     <aside data-designer="ftr-col-center" style="margin: auto;" class="col-xl-8 pb-3 ">
            //         <img src="${this._basePluginUrl}${this.getLocalizator()["footer"][
            //     "your-foxigy-image-link"
            // ]()}" style="width: 100%;align-self: center !important;">
            //     </aside>
            //     <aside data-designer="ftr-col-right" class="col-xl-6 pb-3 text-xl-left">
            //     </aside>
            //     `);
            // thirdRow.append(yourFoxigySection);
            // $(thirdRow).insertAfter(secondRow);

            // const fourthRow = $('<div class="row text-sm-center-var ftr-top" data-designer="ftr-frth-rw"></div>');
            // const paymentsIconsSection = $(
            //     `

            // <aside data-designer="ftr-col-center" style="" class="col-md-18 col-lg-12  pb-3 row img-center">
            //     ` +
            //         (() => {
            //             if (["hu", "ro", "si", "de"].includes(this.getLanguage())) {
            //                 return `<img class="col-3" src="${this._basePluginUrl}/footer/img/comgate.webp" style="" >`;
            //             } else {
            //                 return "";
            //             }
            //         })() +
            //         `
            //     <img class="col-3" src="${this._basePluginUrl}/footer/img/visa.webp" style="">
            //     <img class="col-3" src="${this._basePluginUrl}/footer/img/mastercard.webp" style="">
            //     <img class="col-3" src="${this._basePluginUrl}/footer/img/maestro.webp" style="">
            // </aside>

            // `
            // );
            // fourthRow.append(paymentsIconsSection);
            // $(fourthRow).insertAfter(thirdRow);

            //highlight open hours
            // $(`#footer-contact-column ul li:nth-of-type(${new Date().getUTCDay()})`).css("color", "rgb(250, 167, 39)");

            this._footerAdjustment = true;
        }
    }

    newFooterModule() {
        if (!this._newFooterComponent) {
            const criticalCss = $('link[href*="critical.scss"]');
            // const afterCss = `<link rel="stylesheet" type="text/css" media="screen,print" href="/_after.scss.css?1670417683">;`;
            const afterCss = $('link[href*="_after.scss"]');
            const appCss = $('link[href*="app.css"]');
            const footerComponent = defineCustomElement(FooterComponent);

            console.log("registering");
            const oldFooter = $("footer").get()?.[0];
            $(oldFooter).detach();
            customElements.define("footer-component", footerComponent);
            $("body>main>article").append(
                $(`<footer-component></footer-component>`)
                    .css("display", "contents")
                    // .prop("id", "foxigy-plugin")
                    .prop("criticalCss", criticalCss.prop("href"))
                    .prop("afterCss", afterCss.prop("href"))
                    .prop("appCss", appCss.prop("href"))
                    .prop("oldFooter", oldFooter)
                    .prop("services", this)
            );
            this._newFooterComponent = true;
        }
    }

    cartAdjustment() {
        if (!this._cartAdjustment) {
            const countriesWithState = ["ro"];
            if (
                $("#frm-registerSummaryForm").length > 0 &&
                !/Packeta/i.test(
                    $("#snippet--totalPriceAjax table:nth-of-type(2) tr:nth-of-type(1) td:nth-of-type(1)").text()
                )
            ) {
                defer(
                    () => {
                        return nette.forms;
                    },
                    () => {
                        if (countriesWithState.includes(this.getLanguage())) {
                            for (const stateField of [
                                $("#frm-registerSummaryForm [name='invoice_state']"),
                                $("#frm-registerSummaryForm [name='state']")
                            ]) {
                                stateField.parent().parent().addClass("has-required");
                            }
                            // loadAllLocales();
                            nette.forms["frm-registerSummaryForm"] = {
                                ...nette.forms["frm-registerSummaryForm"],
                                validators: {
                                    invoice_state: (sender: any) => {
                                        const form = sender.form || sender;
                                        const val = nette.getValue(form["invoice_state"]);
                                        const res = val != "" && val != "";

                                        if (!res) return this.getLocalizator()["state-is-required"]();
                                    },
                                    state: (sender: any) => {
                                        let res;
                                        let val;
                                        const form = sender.form || sender;
                                        res = (val = nette.getValue(form["postal_yn"])) != "";
                                        if (res) {
                                            val = nette.getValue(form["state"]);
                                            res = val != "" && val != "";
                                            if (!res) return this.getLocalizator()["state-is-required"]();
                                        }
                                    },
                                    ...nette.forms["frm-registerSummaryForm"].validators
                                }
                            };
                        } else {
                            for (const stateField of [
                                $("#frm-registerSummaryForm [name='invoice_state']"),
                                $("#frm-registerSummaryForm [name='state']")
                            ]) {
                                stateField.parent().parent().remove();
                            }
                        }
                    }
                );
            }

            this._cartAdjustment = true;
        }
    }

    toggleShowMore() {
        // $(".show-less  p:not(:first-of-type)").toggle();
        // $(".show-less  p").toggleClass("truncate-text");

        $(".show-less>*").toggle();
        $(".show-less>p:first-of-type").toggle();
    }

    descriptionShortener() {
        if (!this._descriptionShortener) {
            if (typeof upgates !== "undefined") {
                this.descriptionShortenerUpgates();
            } else if (shoptet !== "undefined") {
                this.descriptionShortenerShoptet();
            }
            this._descriptionShortener = true;
        }
    }

    private descriptionShortenerUpgates() {
        if (
            typeof upgates !== "undefined" &&
            upgates?.pageType === "category" &&
            $("#snippet-products-productList").length
        ) {
            const descriptionElement = $("article .mx-auto-var.max-w-xl");
            descriptionElement.attr("id", "descriptionContainer");

            const afterStyle = $(`<style id="descriptionContainerCss">
                    
                    .show-less .truncate-control {
                        display: block !Important
                    }
    
                    .show-less>p:first-of-type {
                        display: block !Important
                    }
    
                    .show-less .main-image {
                        display: block !Important
                    }
    
                    .show-less>* {
                        display: none;
                    }
                  </style>`);
            $(`head`).append(afterStyle);

            const truncateControl = $(
                `<a href=# class="truncate-control">${this.getLocalizator()["description"]["show-less"]()}</a>`
            );

            descriptionElement.append(truncateControl);

            $(truncateControl).on("click", e => {
                descriptionElement.toggleClass("show-less");
                $(truncateControl).detach();

                console.log(truncateControl);
                if (truncateControl.text() === this.getLocalizator()["description"]["show-more"]()) {
                    truncateControl.text(this.getLocalizator()["description"]["show-less"]());
                } else {
                    truncateControl.text(this.getLocalizator()["description"]["show-more"]());
                }
                descriptionElement.append(truncateControl);
                console.log(truncateControl);
            });
            truncateControl.trigger("click");
        }
    }

    private descriptionShortenerShoptet() {
        if ($("body.type-category.page-category").length) {
            console.log("shoptet test");
            const descriptionSource = $("main#content-in");

            const decriptionContents = descriptionSource.children("h1").nextUntil("div.clear");

            const shortDescriptionElement = $("<div></div>");
            const longDescriptionElement = $("<div></div>");

            descriptionSource.children("h1").after(longDescriptionElement);
            descriptionSource.children("h1").after(shortDescriptionElement);

            shortDescriptionElement.attr("id", "shortDescriptionElement");
            longDescriptionElement.attr("id", "longDescriptionElement");

            let paragraphIndex = 0;
            for (const descContentElement of $(decriptionContents).get()) {
                console.log(descContentElement.tagName);
                if (/p/i.test(descContentElement.tagName) && $(descContentElement).text().trim().length > 0) {
                    paragraphIndex += 1;
                }
                let destinationElement = shortDescriptionElement;
                if (paragraphIndex > 1) {
                    destinationElement = longDescriptionElement;
                }
                const jElement = $(descContentElement);
                jElement.detach();
                jElement.appendTo(destinationElement);
            }

            const afterStyle = $(`<style id="descriptionContainerCss">
                    .truncate-control{
                        width: 100%;
                        display: block;
                        text-align: center;
                    }
                  </style>`);
            $(`head`).append(afterStyle);

            const truncateControlShowLess = $(
                `<a href=# class="truncate-control show-less">
                ${this.getLocalizator()["description"]["show-less"]()}
                </a>`
            );

            const truncateControlShowMore = $(
                `<a href=# class="truncate-control show-more">
                ${this.getLocalizator()["description"]["show-more"]()}
                </a>`
            );

            shortDescriptionElement.append(truncateControlShowMore);
            longDescriptionElement.append(truncateControlShowLess);

            $(truncateControlShowMore).on("click", e => {
                longDescriptionElement.show(100);
                truncateControlShowMore.hide(100);
                truncateControlShowLess.show(100);
                e.preventDefault();
                e.stopPropagation();
            });

            $(truncateControlShowLess).on("click", e => {
                longDescriptionElement.hide(100);
                truncateControlShowMore.show(100);
                truncateControlShowLess.hide(100);
                e.preventDefault();
                e.stopPropagation();
            });

            $(truncateControlShowLess).trigger("click");
        }
    }

    public async productComparatorsService() {
        if (!this._productComparatorsService) {
            this._productComparatorsService = await new ProductComparatorsService(this).init();
        }
        return Promise.resolve(this._productComparatorsService);
    }

    public vueWebAppService() {
        if (!this._vueWebAppService) {
            this._vueWebAppService = new VueWebAppService(this);
        }
        return this._vueWebAppService;
    }

    public searchApiService() {
        if (!this._searchApiService) {
            this._searchApiService = new SearchApiService(this);
        }
        return this._searchApiService;
    }

    init() {
        if (typeof upgates !== "undefined") {
            this.navbarInit();
            this.cartSummary();
            this.footerImage();
            this.categoryPageBackground();
            this.productRatingElement();
            // this.footerAdjustment();
            this.newFooterModule();
            this.cartAdjustment();
            this.descriptionShortener();
            this.productComparatorsService();
        } else if (typeof shoptet !== "undefined") {
            this.descriptionShortener();
        }
    }
}
